module.exports = __webpack_public_path__ + "img/search.951968b6.svg";